































import { Component, Watch, Vue } from "vue-property-decorator";
import { Menu } from "@/models/menus/menu";
import { IMenuItem } from "@/models/menus/abstract/imenu";
import { Getter } from "vuex-class";
import { ActivityAreaDto } from "@/server/app.dtos";

@Component
export default class MenuComponent extends Vue {
  @Getter activityAreas!: ActivityAreaDto[];
  @Watch("$route")
  onRouteChange() {
    this.currentMenu = null;
    this.isSubMenuOpen = false;
    this.isMainMenuOpen = false;
    this.$emit("toggle", false);
  }
  isMainMenuOpen: boolean = false;
  isSubMenuOpen: boolean = false;
  menuConfiguration: Menu = new Menu();
  currentMenu: IMenuItem | null = null;

  created(): void {
    this.loadMenu();
  }

  loadMenu(): void {
    this.menuConfiguration = new Menu();
    if (this.activityAreas.length > 0) {
      const menuActivities = this.menuConfiguration.menus.find(
        (i: IMenuItem) => i.reference == "activities"
      );
      if (menuActivities != null && menuActivities.subMenus != null) {
        const subMenus: IMenuItem[] = [];
        this.activityAreas.map((area: ActivityAreaDto) =>
          subMenus.push({
            title: area.title || "",
            icon: area.icon || "las la-cog",
            url: "/activities/list/" + area.idActivityArea,
            subMenus: []
          })
        );
        if (subMenus.length > 0) {
          menuActivities.subMenus = menuActivities.subMenus.concat(subMenus);
        }
      }
    }
  }

  openSubMenu(m: IMenuItem): void {
    if (m.subMenus && m.subMenus.length > 0) {
      this.isMainMenuOpen = true;
      this.currentMenu = m;
      this.isSubMenuOpen = this.currentMenu != null;
      return;
    }
    this.isSubMenuOpen = false;
    this.navigate(m.url || "/");
  }

  openMenu(): void {
    this.isMainMenuOpen = true;
    this.$emit("toggle", this.isMainMenuOpen);
  }

  toggleOpen(): void {
    this.isMainMenuOpen = !this.isMainMenuOpen;
    if (!this.isMainMenuOpen) {
      this.isSubMenuOpen = false;
      this.currentMenu = null;
    }
    this.$emit("toggle", this.isMainMenuOpen);
  }

  navigate(url: string): void {
    if (this.$route.path !== url) this.$router.push(url);
  }
}
